const headerWrapperConstants = {
    SECONDARY_LABEL: 'Secondary',
    HIDE_CLASS: 'hideElement'
};

export default headerWrapperConstants;
